export const SHOP_TOAST_EVENT = 'vp:shop-toast';

export function showShopToast(message, variant = 'success') {
  window.dispatchEvent(
    new CustomEvent(SHOP_TOAST_EVENT, {
      detail: { message, variant }
    })
  );
}
